var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.1C5.98007 1.1 1.09998 5.98009 1.09998 12C1.09998 18.0199 5.98007 22.9 12 22.9C18.0199 22.9 22.9 18.0199 22.9 12C22.9 5.98009 18.0199 1.1 12 1.1ZM2.89998 12C2.89998 6.9742 6.97418 2.9 12 2.9C17.0258 2.9 21.1 6.9742 21.1 12C21.1 17.0258 17.0258 21.1 12 21.1C6.97418 21.1 2.89998 17.0258 2.89998 12ZM12 9.1C10.3984 9.1 9.09998 10.3984 9.09998 12C9.09998 13.6016 10.3984 14.9 12 14.9C13.6016 14.9 14.9 13.6016 14.9 12C14.9 10.3984 13.6016 9.1 12 9.1ZM10.9 12C10.9 11.3925 11.3925 10.9 12 10.9C12.6075 10.9 13.1 11.3925 13.1 12C13.1 12.6075 12.6075 13.1 12 13.1C11.3925 13.1 10.9 12.6075 10.9 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSong);
export default __webpack_public_path__ + "static/media/song.3328be0dfd0699a0dd8fe0d3d4025ae4.svg";
export { ForwardRef as ReactComponent };